import { render, staticRenderFns } from "./DialogAtualizacaoPagina.vue?vue&type=template&id=80f11b94&"
import script from "./DialogAtualizacaoPagina.vue?vue&type=script&lang=js&"
export * from "./DialogAtualizacaoPagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports